import { render, staticRenderFns } from "./damageMobilierUptecFeature.pug?vue&type=template&id=1bf71b14&lang=pug&"
import script from "./damageMobilierUptecFeature.js?vue&type=script&lang=js&"
export * from "./damageMobilierUptecFeature.js?vue&type=script&lang=js&"
import style0 from "./damageMobilierUptecFeature.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lauramunozruiz/multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bf71b14')) {
      api.createRecord('1bf71b14', component.options)
    } else {
      api.reload('1bf71b14', component.options)
    }
    module.hot.accept("./damageMobilierUptecFeature.pug?vue&type=template&id=1bf71b14&lang=pug&", function () {
      api.rerender('1bf71b14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/damageMobilierUptecFeature/index.vue"
export default component.exports